import React from "react";
import ListItem from 'theme/ListItem';
import { colorList } from "utils/colors";
import i18n from "utils/i18n";
import { StyleSheet } from "react-native";
import _ from "lodash";
import HelperArray from 'utils/helper-array'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperDate from 'utils/helper-date'
import { isTimeslotActive } from 'utils/helper-management-dashboard'

const ManagementDashboardComponentMeetingRoomsTimeslots = ( { timeslot = null, bookings = null, onPress = null, now = HelperDate.date(), loading = false } ) => {

	const title = `${ timeslot.timeslot_start.substr( 0, 5 ) } - ${ timeslot.timeslot_end.substr( 0, 5 )  }`;

	let description = null;
	let accessoryLeft = null;
	let accessoryRight = null;
	
	const iconProps = {
		style: {
			fontSize: 20
		}
	}

	switch( true ) {
		case loading && bookings === null:
			onPress = null;
			description = i18n.t('management:pages.dashboard.meeting_rooms.timeslots.loading');
			break;

		case bookings !== null && !_.isEmpty( bookings ):
			// Get the unique employees
			const employees = _.uniqBy( _.map( bookings, o => {
				return _.get(o, 'employee', {});
			} ), 'guid' );
			
			// Create a string of all the employee names
			const employeeNames = HelperArray.naturalJoin( _.map( employees, o => {
				return _.get(o, 'name', null);
			} ) )
			
			description = i18n.t( 'management:pages.dashboard.meeting_rooms.timeslots.booked', { name: employeeNames, employee_count: _.size( employees ) });
			accessoryLeft = ( props ) => {
				return <Icon icon={IconSystemConstants.PERSON} {...props} {...iconProps} fill={colorList.GREEN.primary} />;
			};
			
			accessoryRight = ( props ) => {
				return <Icon icon={IconSystemConstants.DETAIL} {...props} {...iconProps} fill={colorList.GREY.dark} />;
			};
			break;
			
		default:
			onPress = null; // On press not required when we have nothing to show as details
			description = i18n.t( 'management:pages.dashboard.meeting_rooms.timeslots.available');
			
			accessoryLeft = ( props ) => {
				return (
					<Icon icon={ IconSystemConstants.PERSON }
						{ ...props }
						{ ...iconProps }
						fill={ colorList.GREY.primary }
					/>
				);
			}
	}

	const active = isTimeslotActive(now, timeslot);
	
	return (
		<ListItem
			key={ `timeslot_${timeslot.guid}` }
			style={ active ? styles.listItemActive : null }
			title={ title }
			description={ description }
			accessoryLeft={ accessoryLeft }
			accessoryRight={ accessoryRight }
			onPress={ onPress }
		/>
	);
};

export const styles = StyleSheet.create({
	listItemActive: {
		backgroundColor: colorList.PRIMARY.light
	}
});

export default ManagementDashboardComponentMeetingRoomsTimeslots
